module.exports = __webpack_public_path__ + "static/calorex_home_slide_familia_calorex_lp-6806ff9f4bc5292614fc851cf954a6a2.png";